<template>
  <div>
    <v-autocomplete
      clearable
      label="Satıcı Ara"
      :items="items"
      item-text="isimAra"
      item-value="id"
      v-model="Satici"
      :search-input.sync="searchAuto"
      return-object
      id="searchText"
    >
      <template v-slot:append-outer>
        <v-icon color="info" @click="open()">search</v-icon>
      </template>
    </v-autocomplete>

    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent max-width="900px">
        <v-card>
          <v-card-title>
            <span class="headline">Satıcı Ara</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md6>
                  <v-select
                    v-model="searchParams.SaticiTipi"
                    @change="setSaticiTip()"
                    :items="itemsaticitip"
                    item-text="Aciklama"
                    item-value="Kod"
                    :label="$t('Seller-Type')"
                    hide-details=""
                  >
                  </v-select>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    label="Kod"
                    v-model="searchParams.Kod"
                    @keyup.enter="search"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    label="Isim"
                    v-model="searchParams.Isim"
                    @keyup.enter="search"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    label="Unvan"
                    v-model="searchParams.Cari_Unvan"
                    @keyup.enter="search"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 md6>
                  <v-radio-group v-model="searchParams.IcDis" row>
                    <v-radio label="Tümü" :value="0"></v-radio>
                    <v-radio label="Yurtiçi" :value="1"></v-radio>
                    <v-radio label="Yurtdışı" :value="2"></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex xs12 sm2 md2>
                  <v-btn block color="success" @click="search()">Ara</v-btn>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm12 md12>
                  <v-data-table
                    :headers="headers"
                    :items="items"
                    hide-actions
                    :loading="loadingResult"
                    class="elevation-1"
                  >
                    <template slot="items" slot-scope="props">
                      <tr @click="setItem(props.item)">
                        <td class="text-xs-left">{{ props.item.isim }}</td>
                        <td class="text-xs-left">{{ props.item.kod }}</td>
                        <td class="text-xs-left">{{ props.item.CariKod }}</td>
                        <td class="text-xs-left">{{ props.item.CariUnvan }}</td>
                        <td class="text-xs-left">{{ props.item.Sehir }}</td>
                        <td class="text-xs-left">
                          {{ props.item.Yer }}
                        </td>
                        <td class="text-xs-left">
                          {{ getIcDisType(props.item.YurtIci_YurtDisi) }}
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click.native="dialog = false"
              >Kapat</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import tool from "@/components/app/coper/tools.js";

export default {
  props: {
    value: {
      type: Object,
    },
    tip: {
      type: Number,
      default: 0,
    },
    icDisBool: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    Satici: {
      get: function () {
        var r = {
          id: "",
          isim: "",
          kod: "",
          isimAra: "",
          YurtIci_YurtDisi: "",
          CariKod: "",
          KDV: 0,
        };
        if (
          this.value != undefined &&
          this.value != null &&
          this.value.id != null
        ) {
          r = {
            id: this.value.id,
            KDV: this.value.KDV,
            isim: this.value.isim,
            kod: this.value.kod,
            YurtIci_YurtDisi: this.value.YurtIci_YurtDisi,
            isimAra: this.IsimAra(this.value),
            CariKod: this.value.CariKod,
          };
        }
        this.SetItems(r);
        return r;
      },
      set: function (newValue) {
        if (newValue == null) {
          newValue = {
            id: "",
            isim: "",
            kod: "",
            isimAra: "",
            YurtIci_YurtDisi: "",
            CariKod: "",
            KDV: 0,
          };
        }
        this.$emit("input", newValue);
      },
    },
  },

  data() {
    return {
      searchAuto: null,
      itemsaticitip: [
        {
          Aciklama: "Otel",
          Kod: 1,
        },
        {
          Aciklama: "Arac",
          Kod: 2,
        },
        {
          Aciklama: "Restaurant",
          Kod: 3,
        },
        {
          Aciklama: "Acente",
          Kod: 4,
        },
        {
          Aciklama: "RentACar",
          Kod: 5,
        },
        {
          Aciklama: "Rehber",
          Kod: 6,
        },
        {
          Aciklama: "Muze",
          Kod: 7,
        },
        {
          Aciklama: "Charter",
          Kod: 8,
        },
        {
          Aciklama: "Gemi",
          Kod: 9,
        },
        {
          Aciklama: "Diger",
          Kod: 10,
        },
        {
          Aciklama: "Vize",
          Kod: 11,
        },
        {
          Aciklama: "TurOperatoru",
          Kod: 12,
        },
        {
          Aciklama: "Sigorta",
          Kod: 14,
        },
        {
          Aciklama: "Feribot",
          Kod: 15,
        },
        {
          Aciklama: "Golf",
          Kod: 16,
        },
      ],
      IcDis: [
        {
          text: "Yurtiçi",
          value: 1,
        },
        {
          text: "Yurtdışı",
          value: 2,
        },
        {
          text: "Tümü",
          value: 0,
        },
      ],
      loadingResult: false,
      message: null,
      dialog: false,
      loading: false,
      items: [],
      select: null,
      headers: [
        {
          text: "İsim",
        },
        {
          text: "Kod",
        },
        {
          text: "Cari Kod",
        },
        {
          text: "Cari Ünvan",
        },
        {
          text: "Şehir",
        },
        {
          text: "İlçe",
        },
        {
          text: "İç Dış",
        },
      ],
      searchParams: {
        SaticiTipi: 1,
        IcDis: 0,
        Ref: 0,
        Kod: null,
        Cari_Unvan: null,
        Sehir: null,
        Yer: null,
        PasifKayit: false,
        Cari_Kod: null,
      },
      ayrac: "  -  ",
    };
  },
  watch: {
    searchAuto(val) {
      if (val != undefined && val == "") {
        this.items = [
          {
            id: "",
            isim: "",
            kod: "",
            isimAra: "",
            YurtIci_YurtDisi: "",
            CariKod: "",
            KDV: 0,
          },
        ];
        this.Model = {
          id: "",
          isim: "",
          kod: "",
          isimAra: "",
          YurtIci_YurtDisi: "",
          CariKod: "",
          KDV: 0,
        };
      } else {
        val &&
          val.indexOf(this.ayrac) == -1 &&
          val.length > 1 &&
          this.searchforAuto(val);
      }
    },
  },
  methods: {
    setSaticiTip() {
      this.$emit("setSeller", this.searchParams.SaticiTipi);
      this.items = [];
      this.Satici = null;
    },
    getIcDisType(val) {
      var result = this.IcDis.find((x) => x.value == val);
      return result.text;
    },
    SetItems(v) {
      var vid = String(v.id);

      if (v.id != null && vid.length > 0) {
        this.items = [v];
      } else {
        this.items = [];
      }
    },
    open() {
      this.searchParams.Ref = 0;
      this.searchParams.Kod = null;
      this.searchParams.Cari_Unvan = null;
      this.searchParams.Cari_Kod = null;
      this.searchParams.Isim = null;
      this.$emit("setSeller", this.searchParams.SaticiTipi);
      this.dialog = true;
    },
    isimAraForSearchAuto(v) {
      var text = null;
      if (v.Isim != null) {
        text = v.Isim.replace(this.ayrac, "-");
      }
      text = text + this.ayrac;
      if (v.Kod != null) {
        text = text + v.Kod.replace(this.ayrac, "-");
      }
      return text;
    },
    IsimAra(v) {
      var text = null;
      if (v.isim != null) {
        text = v.isim.replace(this.ayrac, "-");
      }
      text = text + this.ayrac;
      if (v.kod != null) {
        text = text + v.kod.replace(this.ayrac, "-");
      }
      return text;
    },
    setItem(val) {
      this.Satici = val;
      this.dialog = false;
    },
    search() {
      this.loadingResult = true;

      tool.http_post(this, "SaticiAraV2", this.searchParams).then(
        (response) => {
          this.items = [];
          if (response.body.Status == true) {
            response.body.data.forEach((element) => {
              this.items.push({
                id: element.Ref,
                isim: element.Isim,
                KDV: element.KdvPrm,
                kod: element.Kod,
                CariKod: element.Cari_Kod,
                CariUnvan: element.Cari_Unvan,
                Sehir: element.Sehir,
                Yer: element.Yer,
                YurtIci_YurtDisi: element.IcDis,
                isimAra: this.IsimAra(element),
              });
            });
            this.loadingResult = false;
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
            this.loadingResult = false;
          }
        },
        (response) => {
         this.text1 = $t('Error-Occured-Please-Try-Again')
          this.snackbar = true;
          this.loadingResult = false;
        }
      );
    },
    searchforAuto(val) {
      this.loadingResult = true;
      this.searchParams.Kod =  val;
      tool.http_post(this, "SaticiAraV2", this.searchParams).then(
        (response) => {
          this.items = [];
          if (response.body.Status == true) {
            response.body.data.forEach((element) => {
              this.items.push({
                id: element.Ref,
                isim: element.Isim,
                KDV: element.KdvPrm,
                kod: element.Kod,
                CariKod: element.Cari_Kod,
                CariUnvan: element.Cari_Unvan,
                Sehir: element.Sehir,
                Yer: element.Yer,
                YurtIci_YurtDisi: element.IcDis,
                isimAra: this.isimAraForSearchAuto(element),
              });
            });
            this.loadingResult = false;
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
            this.loadingResult = false;
          }
        },
        (response) => {
         this.text1 = $t('Error-Occured-Please-Try-Again')
          this.snackbar = true;
          this.loadingResult = false;
        }
      );
    },
  },
};
</script>